import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrOrderAcknowledgeModule } from './kn-br-order-acknowledge/kn-br-order-acknowledge.module';
import { ConfigModule, RoutingConfig, AuthGuard } from '@spartacus/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrOrderAcknowledgeModule,
    RouterModule.forChild([
      {
        data: { pageLabel: '/customer-360/order/edit/confirmation', cxRoute: 'orderEditConfirmation' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          orderReturnConfirmation: {
            paths: ['customer-360/order/return/confirmation/:orderCode/:type/:rma'],
            paramsMapping: { orderCode: 'code', type: 'type', rma: 'rma' },
          },
          orderCancelConfirmation: {
            paths: ['customer-360/order/cancel/confirmation/:orderCode/:type'],
            paramsMapping: { orderCode: 'code', type: 'type' },
          },
          orderEditConfirmation: {
            paths: ['customer-360/order/edit/confirmation/:orderCode/:type/:orderNumber'],
            paramsMapping: { orderCode: 'code', type: 'type', orderNumber: 'orderNumber' },
          },
        },
      },
    } as RoutingConfig),
  ],
})
export class KnBrAcknowledgeModule {}
